import { urlOptionalEnum } from '@/lib/url-state/codecs';

/** "Has" or "Missing" for a content field (SEO title, teaser, description) on the bulk-edit lists. */
export const CONTENT_EXISTENCE_FILTERS = ['present', 'missing'] as const;

export type ContentExistenceFilter = (typeof CONTENT_EXISTENCE_FILTERS)[number];

/** A filter's value, or null (off) for anything else. */
export function parseContentExistence(value: unknown): ContentExistenceFilter | null {
  return value === 'present' || value === 'missing' ? value : null;
}

/** The filter in a page's URL (`seoTitle=missing`); null, and left out, when off. */
export function urlContentExistence(key: string) {
  return urlOptionalEnum(key, CONTENT_EXISTENCE_FILTERS);
}
